import { render } from "./RegNewTeam.vue?vue&type=template&id=544875ba&scoped=true"
import script from "./RegNewTeam.vue?vue&type=script&lang=js"
export * from "./RegNewTeam.vue?vue&type=script&lang=js"

import "./RegNewTeam.vue?vue&type=style&index=0&id=544875ba&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-544875ba"]])

export default __exports__